import React, { ReactNode } from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import styles from './Topic.module.css';

interface ITopicProps {
  title: string,
  children: ReactNode,
}

const Topic = ({ title, children }: ITopicProps) => {
  const [open, setOpen] = React.useState(false);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  return (
    <>
      <ListItem
        button
        onClick={handleClick}
        className={styles.topic}
        disableGutters
      >
        <ListItemText disableTypography primary={title} />
        {open ? <ExpandLess color="primary" /> : <ExpandMore color="primary" />}
      </ListItem>
      <Collapse
        in={open}
        timeout="auto"
        mountOnEnter
        unmountOnExit
        className={styles.collapseWrapper}
      >
        {children}
      </Collapse>
    </>
  );
};

export default Topic;
